export const appID = 'wxd5a09154b1161e02'
export const wxBaseURL = 'http://wx.xcims.com/#'
